import { TableCard } from '../../../../components'
import { HistoricoListHeader } from './components/header/HistoricoListHeader'
import { PacienteHistoricoHeading } from './components/header/PacienteHistoricoHeading'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { HistoricoTable } from './table/HistoricoTable'

const HistoricoList = () => (
  <>
    <PacienteHistoricoHeading />
    <TableCard>
      <HistoricoListHeader />
      <HistoricoTable />
    </TableCard>
  </>
)

export const HistoricoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <HistoricoList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
